<template>
    <x-dialog
        v-model="isOpen"
        :width="width"
        persistent
        :content-class="contentClass"
    >
        <x-container fluid text-xs-center>
            <x-layout>
                <x-flex xs12>
                    <h2>{{ computedTitle }}</h2>
                    <slot/>
                </x-flex>
            </x-layout>

            <x-layout>
                <x-flex xs12 class="response-actions">
                    <template v-if="confirmation">
                        <x-btn @click="resolveAndClose(false)" large outline color="red">{{ cancelText }}</x-btn>
                        <x-btn :disabled="actionDisabled" @click="resolveAndClose(true)" large depressed>{{ computedActionText }}</x-btn>
                    </template>

                    <template v-else>
                        <x-btn :disabled="actionDisabled" @click="resolveAndClose(true)" large depressed>{{ computedActionText }}</x-btn>
                    </template>
                </x-flex>
            </x-layout>
        </x-container>
    </x-dialog>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            title: {
                type: String
            },
            width: {
                type: [String, Number],
                default: 800
            },
            confirmation: {
                type: Boolean,
                default: false
            },
            actionText: {
                type: String
            },
            actionDisabled: {
                type: Boolean,
                default: false,
            },
            cancelText: {
                type: String,
                default: 'Cancel'
            },
            contentClass: {
                type: String,
                default: 'dialog-modal'
            },
        },
        data() {
            return {
                isOpen: false,
                resolve: false
            }
        },
        computed: {
            computedTitle() {
                return this.title || (this.confirmation ? 'Are you sure?' : 'Alert');
            },
            computedActionText() {
                return this.actionText || (this.confirmation ? 'Yes' : 'OK');
            }
        },
        methods: {
            open() {
                this.isOpen = true;

                return new Promise((resolve) => {
                    this.resolve = resolve
                });
            },
            resolveAndClose(confirmed) {
                if (this.resolve) {
                    this.resolve(confirmed);
                    this.resolve = false;
                }

                this.isOpen = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        padding: 40px;
        font-family: $font-title;

        h2 {
            color: $color-primary;
        }

        ::v-deep {
            p {
                font-size: rem(18px);

                + p {
                    margin-top: 0.66em;
                }
            }

            p + ul {
                margin-top: 1em;
            }
        }

        .response-actions {
            display: flex;
            justify-content: space-evenly;
            margin-top: 32px;

            .x-btn {
                min-width: 113px;
            }
            .theme--dark.x-btn.x-btn--disabled:not(.x-btn--icon):not(.x-btn--flat):not(.x-btn--outline) {
                background-color: #808DDE !important;
            }
        }
    }
</style>
